import React, { useState, useEffect } from "react";
import "./Sidebar.css";
import Logo from "../../assets/img/logo.png";
import {
  UilSignOutAlt,
  UilBars,
  UilStore,
  UilShoppingBag,
  UilHome,
} from "@iconscout/react-unicons";
import { motion } from "framer-motion";
import { logoutUser } from "../../redux/apiCalls";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { useRouteMatch } from "react-router-dom";
import { SidebarData } from "../../Sidebar/SidebarData";
import { toast } from "react-toastify";

const Sidebar = () => {
  let { url } = useRouteMatch();

  const [expanded, setExpanded] = useState(true);

  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const sidebarVariants = {
    true: {
      left: "0",
    },
    false: {
      left: "-100%",
    },
  };

  const handleLogout = (e) => {
    e.preventDefault();
    const auth2 = window?.gapi && window?.gapi?.auth2?.getAuthInstance();
    if (auth2 != null) {
      auth2.signOut().then(() => {
        toast.success("Signed out successfully!");
        // console.log("User signed out from Google.");
      });
    }
    // Sign out of your app
    dispatch(logoutUser);
    history.push("/");
  };

  // Home and Shop both land on the landing page. One handler, two
  // entry points: Home sits at the top of the menu so a user who
  // opened their account panel can always see the way back, and Shop
  // stays where returning users already look for it.
  const goHome = (e) => {
    e.preventDefault();
    history.push("/");
  };

  const goToCart = (e) => {
    e.preventDefault();
    history.push("/cart");
  };

  // Make My Orders the default route whenever i navigate back
  // Find the index of the sidebar item that matches the current path
  const defaultSelected = SidebarData.findIndex((item) =>
    location.pathname.includes(item.path),
  );

  // Use the index as the default selected item, fallback to 0 (My Orders) if no match found
  const [selected, setSelected] = useState(
    defaultSelected !== -1 ? defaultSelected : 0,
  );

  // Update selected item when location changes
  useEffect(() => {
    const currentSelected = SidebarData.findIndex((item) =>
      location.pathname.includes(item.path),
    );
    if (currentSelected !== -1) {
      setSelected(currentSelected);
    } else {
      setSelected(0); // Default to My Orders
    }
  }, [location.pathname]);

  return (
    <>
      {/* Overlay backdrop for mobile */}
      {expanded && window.innerWidth <= 768 && (
        <div className="sidebar-overlay" onClick={() => setExpanded(false)} />
      )}
      <div
        className="bars"
        style={
          expanded
            ? {
                left: "60%",
                marginTop: "1rem",
              }
            : { left: "8px", marginTop: "1rem" }
        }
        onClick={() => setExpanded(!expanded)}
      >
        <UilBars color="#fff" size="30" />
      </div>
      <motion.div
        className="Sidebar"
        variants={sidebarVariants}
        animate={window.innerWidth <= 768 ? `${expanded}` : ""}
      >
        {/* Logo */}
        <div className="logo" onClick={goHome} role="link" title="Home">
          <img src={Logo} alt="Lusuku home" />
        </div>
        {/* Menu */}
        <div className="menu">
          {/* Home: always the first row, so the way back to the landing
              page is visible without scrolling the account menu. */}
          <div
            className="menuItem"
            onClick={goHome}
            title="Back to the home page"
          >
            <UilHome />
            <span>Home</span>
          </div>
          {SidebarData.map((item, index) => {
            return (
              <div
                key={index}
                className={selected === index ? "menuItem active" : "menuItem"}
                onClick={() => {
                  setSelected(index);
                  history.push(`${url}${item.path}`);
                }}
              >
                {item.icon}
                <span>{item.heading}</span>
              </div>
            );
          })}
          {/* Shop */}
          <div className="menuItem" onClick={goHome}>
            <UilStore />
            <span>Shop</span>
          </div>
          {/* Cart */}
          <div className="menuItem" onClick={goToCart}>
            <UilShoppingBag />
            <span>Cart</span>
          </div>
          {/* Logout */}
          <div className="menuItem" onClick={handleLogout}>
            <UilSignOutAlt />
            <span>Logout</span>
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default Sidebar;
